import React, { Component } from "react"
import { Button, FormControl, Modal, OverlayTrigger, Spinner } from "react-bootstrap"
import TrashCan from "src/pages/dynamic_forms/Utils/TrashCan/TrashCan"
import PortalAssignmentTypes from "../../types/portalRoleTypes/PortalAssignmentTypes"
import PortalRoleAndAssignmentTypes from "../../types/portalRoleTypes/PortalRoleAndAssignmentTypes"
import PortalAssignmentBoilerPlate from "../../utils/boilerPlates/roleBoilerplates/PortalAssignmentBoilerPlate"
import ratmService from "../../utils/RATMService"
import mutate from "../../utils/Mutate"
import ratmCrud from "../../utils/RATMCrud"
import rmAudit from "../../utils/rmAudit/RMAudit"
import dayjs from "dayjs"
import cloneRoleAndAssignments from "../../utils/CloneRoleAndAssignment"
import PortalRoleAndAssignmentsBoilerplate from "../../utils/boilerPlates/roleBoilerplates/PortalRoleAndAssignmentsBoilerplate"
import "./RoleManagementAddOrEditRAA.css"

interface State {
  eventKeys: Array<string | number>
  newOrUpdatedRAA: PortalRoleAndAssignmentTypes
}

class RoleManagementAddOrEditRAA extends Component<{}, State> {

  state = {
    eventKeys: ["", "", -1],
    newOrUpdatedRAA: cloneRoleAndAssignments(ratmService.state.addOrEditRoleId),
  }

  componentDidMount(): void {
      this.setTitleText(this.state.newOrUpdatedRAA.Role.RoleName)
  }

  manageThisState = (keys: { key: string, value?: any }[]) => {
    this.setState(mutate(this.state, keys))
  }

  handleChange = (event: { target: { value: any } }) => {
    const input = event.target.value
    const { eventKeys, newOrUpdatedRAA } = this.state
    let raa = newOrUpdatedRAA
    //@ts-ignore
    if (eventKeys[2] < 0) {
      raa[eventKeys[0]][eventKeys[1]] = input
    } else {
      raa[eventKeys[0]][eventKeys[2]][eventKeys[1]] = input
    }
    this.manageThisState([{ key: "newOrUpdatedRAA", value: raa }])
  }

  setTitleText = (title: string) => {
    const { state} = ratmService
    const { addOrEditRoleId } = state
    const titleText = `${addOrEditRoleId < 1 ? "Add a new role" : `Edit: ${title}`}`
    let elem = document.getElementById("a5fc3cd46f0d47a1a1b8c6e5477f195a")
    if(elem){
      elem.innerHTML = titleText
    }
  }

  render() {

    const { manageState, state, timeFormat } = ratmService
    const { addOrEditRoleId, busyId } = state
    const { addPortalRolesAndAssignments, editPortalRolesAndAssignments } = ratmCrud
    const { auditRAA, rmAuditPopover } = rmAudit
    const { newOrUpdatedRAA } = this.state
    const stateOfNewOrUpdatedRAA = auditRAA(newOrUpdatedRAA)

    // console.log("RoleManagementAddOrEditRAA state", this.state)
    // console.log("RoleManagementAddOrEditRAA stateOfNewOrUpdatedRAA", stateOfNewOrUpdatedRAA)

    return (
      <div className="RoleManagementAddOrEditRAA">
        <Modal
          id="e80e39d7c68d47a6a231d76a719a003f"
          show={true}
          backdrop="static"
          keyboard={true}
          centered={true}
        >
          <Modal.Header>
            <div className="RoleManagementAddOrEditRAAModalHeader">
              <div className="RoleManagementAddOrEditRAAModalHeaderLeft">
                <p id="a5fc3cd46f0d47a1a1b8c6e5477f195a"></p>
              </div>
              <div className="RoleManagementAddOrEditRAAModalHeaderRight">
                <div className="RoleManagementAddOrEditRAAIsProtected"
                  onClick={() => {
                    let raa = this.state.newOrUpdatedRAA
                    raa.Role.IsProtected = !raa.Role.IsProtected
                    this.manageThisState([{ key: "newOrUpdatedRAA", value: raa }])
                  }}
                >
                  <p>Protected</p>
                  <FormControl
                    checked={newOrUpdatedRAA.Role.IsProtected}
                    onChange={() => null}
                    type="checkbox"
                  />
                </div>
              </div>
            </div>
          </Modal.Header>
          <Modal.Body>
            <div className="RoleManagementAddOrEditRAAModalModalBody">
              <div className="RoleManagementAddOrEditRAAModalModalBodyInputItem">
                <div className="RoleManagementAddOrEditRAAModalModalBodyInputItemHeader">
                  <p>Name</p>
                  {!newOrUpdatedRAA.Role.RoleName &&
                    <p className="RoleManagementAddOrEditRAAModalModalBodyInputItemHeaderMissingField">*</p>
                  }
                </div>
                <FormControl
                  onFocus={() => this.manageThisState([{ key: "eventKeys", value: ["Role", "RoleName", -1] }])}
                  placeholder={newOrUpdatedRAA.Role.RoleName || ""}
                  onChange={this.handleChange}
                  value={newOrUpdatedRAA.Role.RoleName || ""}
                  maxLength={20}
                />
              </div>
              <div className="RoleManagementAddOrEditRAAModalModalBodyInputItem">
                <div className="RoleManagementAddOrEditRAAModalModalBodyInputItemHeader">
                  <p>Category</p>
                  {!newOrUpdatedRAA.Role.RoleCategory &&
                    <p className="RoleManagementAddOrEditRAAModalModalBodyInputItemHeaderMissingField">*</p>
                  }
                </div>
                <FormControl
                  onFocus={() => this.manageThisState([{ key: "eventKeys", value: ["Role", "RoleCategory", -1] }])}
                  placeholder={newOrUpdatedRAA.Role.RoleCategory || ""}
                  onChange={this.handleChange}
                  value={newOrUpdatedRAA.Role.RoleCategory || ""}
                  maxLength={20}
                />
              </div>
              <div className="RoleManagementAddOrEditRAAModalModalBodyInputItem">
                <div className="RoleManagementAddOrEditRAAModalModalBodyInputItemHeader">
                  <p>Description</p>
                  {!newOrUpdatedRAA.Role.Description &&
                    <p className="RoleManagementAddOrEditRAAModalModalBodyInputItemHeaderMissingField">*</p>
                  }
                </div>
                <FormControl
                  onFocus={() => this.manageThisState([{ key: "eventKeys", value: ["Role", "Description", -1] }])}
                  placeholder={newOrUpdatedRAA.Role.Description || ""}
                  onChange={this.handleChange}
                  value={newOrUpdatedRAA.Role.Description || ""}
                  as="textarea"
                  rows={4}
                  maxLength={200}
                />
              </div>
              <div className="RoleManagementAddOrEditRAAModalModalBodyAssignments">
                <div className="RoleManagementAddOrEditRAAModalModalBodyAssignmentsHeader">
                  <div className="RoleManagementAddOrEditRAAModalModalBodyAssignmentsHeaderLeft">
                    <p>Targets</p>
                    {(stateOfNewOrUpdatedRAA.missingTargets > 0 || stateOfNewOrUpdatedRAA.noAssignments) &&
                      <p className="RoleManagementAddOrEditRAAModalModalBodyAssignmentsCantSave">*</p>
                    }
                  </div>
                  <div className="RoleManagementAddOrEditRAAModalModalBodyAssignmentsHeaderRight">
                    <span
                      className="material-icons"
                      onClick={() => {
                        let raa = newOrUpdatedRAA
                        raa.Assignments.push(JSON.parse(JSON.stringify(PortalAssignmentBoilerPlate)))
                        this.manageThisState([{ key: "newOrUpdatedRAA", value: raa }])
                      }}
                    >add</span>
                  </div>
                </div>
                {newOrUpdatedRAA.Assignments.map((assignment: PortalAssignmentTypes, i: number) =>
                  <div className="RoleManagementAddOrEditRAAModalModalBodyAssignmentItem"
                    key={i}
                    style={{ display: assignment.DeletedDate ? "none" : "flex" }}
                  >
                    <div className="RoleManagementAddOrEditRAAModalModalBodyAssignmentItemInput">
                      <FormControl
                        onFocus={() => this.manageThisState([{ key: "eventKeys", value: ["Assignments", "Target", i] }])}
                        placeholder={assignment.Target || ""}
                        onChange={this.handleChange}
                        value={assignment.Target || ""}
                        maxLength={200}
                      />
                    </div>
                    <div className="RoleManagementAddOrEditRAAModalModalBodyAssignmentItemDelete"
                      onClick={() => {
                        let raa = newOrUpdatedRAA
                        if (!raa.Assignments[i].PortalRoleAssignmentId) {
                          raa.Assignments.splice(i, 1)
                        } else {
                          raa.Assignments[i].DeletedDate = dayjs().format(timeFormat)
                        }
                        this.manageThisState([{ key: "newOrUpdatedRAA", value: raa }])
                      }}
                    >
                      <TrashCan
                        color="#dc3545"
                      />
                    </div>
                  </div>
                )}
                {stateOfNewOrUpdatedRAA.noAssignments &&
                  <div className="RoleManagementAddOrEditRAAModalModalBodyAssignmentsEmpty">
                    <p>Add at least one target</p>
                    <span className="material-icons">adjust</span>
                  </div>
                }
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <div className="RoleManagementAddOrEditRAAModalModalFooter">
              <div className="RoleManagementAddOrEditRAAModalModalFooterLeft">
                <Button variant="secondary"
                  onClick={() => {
                    this.manageThisState([
                      { key: "eventKeys", value: ["", ""] },
                      { key: "newOrUpdatedRAA", value: JSON.parse(JSON.stringify(PortalRoleAndAssignmentsBoilerplate)) }
                    ])
                    manageState([
                      { key: "addOrEditRoleId", value: -1 },
                    ])
                  }}
                >
                  Back
                </Button>
              </div>
              <div className="RoleManagementAddOrEditRAAModalModalFooterRight">
                {
                  busyId !== 1 && <div className="RoleManagementAddOrEditRAAModalModalFooterRightNotBusy">
                    {
                      !stateOfNewOrUpdatedRAA.canSave && (
                        <OverlayTrigger
                          placement="right"
                          overlay={
                            rmAuditPopover(
                              stateOfNewOrUpdatedRAA.roleIssues.length > 0 ? "Role issues" : null,
                              stateOfNewOrUpdatedRAA.roleIssues.length > 0 ? stateOfNewOrUpdatedRAA.roleIssues : null,
                              stateOfNewOrUpdatedRAA.missingTargets > 0 || stateOfNewOrUpdatedRAA.noAssignments ? "Target issues" : null,
                              stateOfNewOrUpdatedRAA.noAssignments
                                ? ["No targets"]
                                : [`${stateOfNewOrUpdatedRAA.missingTargets} empty target${stateOfNewOrUpdatedRAA.missingTargets > 1 ? "s" : ""}`]
                            )
                          }
                        >
                          <div className="material-icons RoleManagementAddOrEditRAAModalModalFooterRightAuditInfo">info</div>
                        </OverlayTrigger>
                      )
                    }
                    <Button
                      disabled={!stateOfNewOrUpdatedRAA.canSave}
                      onClick={
                        () => addOrEditRoleId < 1 ?
                          addPortalRolesAndAssignments(newOrUpdatedRAA) :
                          editPortalRolesAndAssignments(newOrUpdatedRAA)
                      }
                    >
                      Save
                    </Button>
                  </div>
                }
                {
                  busyId === 1 &&
                  <div className="RoleManagementAddOrEditRAAModalModalFooterRightBusy">
                    <Spinner className="fc5773659914f0f94dbaebcf0a3ce56" animation="border" />
                  </div>
                }
              </div>
            </div>
          </Modal.Footer>
        </Modal>
      </div>
    )
  }
}

export default RoleManagementAddOrEditRAA